var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 36,
    viewBox: "0 0 110 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9765 33.2977L34.2764 27.6556C34.5136 27.2298 34.5136 26.7188 34.2764 26.3143L33.2411 24.5259L27.7197 33.979H29.8118C30.2863 33.979 30.7392 33.7235 30.9765 33.2977Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0243 33.2974L36.8223 31.9561C37.0596 31.5303 37.0596 31.0193 36.8223 30.6148L35.7871 28.8477L32.7676 34H34.8597C35.3126 33.9787 35.7655 33.7233 36.0243 33.2974Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21502 33.979L3.69366 24.5259L2.6584 26.3143C2.42116 26.7401 2.42116 27.2511 2.6584 27.6556L5.93671 33.2977C6.17396 33.7235 6.62688 33.979 7.12294 33.979H9.21502Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21319 28.7625L0.177935 30.5296C-0.0593116 30.9554 -0.0593116 31.4664 0.177935 31.8709L0.997513 33.2974C1.23476 33.7232 1.68768 33.9787 2.18375 33.9787H4.27583L1.21319 28.7625Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3118 33.9788H24.7647C25.2607 33.9788 25.7137 33.7233 25.9509 33.2975L31.7742 23.3334C32.0115 22.9075 32.0115 22.3966 31.7742 21.992L30.739 20.2036L23.4922 32.5736L24.3118 33.9788Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2404 33.9789L7.01519 21.6089H5.37604L5.16036 22.0134C4.92311 22.4392 4.92311 22.9502 5.16036 23.3547L10.9837 33.2975C11.2209 33.7234 11.6739 33.9789 12.1699 33.9789H14.2404Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4137 30.7422L29.2507 19.0536C29.488 18.6278 29.488 18.1168 29.2507 17.7123L28.2155 15.9238L20.9902 28.2938L22.4137 30.7422Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1709 21.6089L16.0079 33.2975C16.2452 33.7234 16.6981 33.9789 17.1941 33.9789H19.2862L12.0394 21.6089H9.1709Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0874 21.6089H14.1973L21.0343 33.2975C21.2715 33.7234 21.7245 33.9789 22.2205 33.9789H24.3126L17.0874 21.6089Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7667 6.2583H15.1669C14.6708 6.2583 14.2395 6.51379 13.9807 6.93961L12.9238 8.70675H23.9881L22.9529 6.91832C22.6941 6.51379 22.2411 6.2583 21.7667 6.2583Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2874 2H17.6482C17.1522 2 16.7208 2.25549 16.462 2.68131L15.4268 4.46974H21.5089L20.4736 2.68131C20.2364 2.25549 19.7835 2 19.2874 2Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.693 11.6236L25.4557 11.2404C25.2185 10.8146 24.7656 10.5591 24.2695 10.5591H12.6229C12.1268 10.5591 11.6954 10.8146 11.4366 11.2404L10.4014 13.0288H24.8734L25.693 11.6236Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7949 14.8594H10.1209C9.62484 14.8594 9.19349 15.1149 8.93467 15.5407L7.89941 17.3291H22.3715L23.7949 14.8594Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4328 19.8205L5.37598 21.6089H19.848L21.2931 19.1392H7.61903C7.12297 19.1605 6.67005 19.4159 6.4328 19.8205Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.693 11.6235L18.4678 23.9935L19.9128 26.4632L26.7498 14.7746C26.9871 14.3488 26.9871 13.8378 26.7498 13.4333L25.693 11.6235Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.406 12.1417C107.289 12.1417 108 11.4532 108 10.5711V10.5496C108 9.68896 107.289 8.97896 106.406 9.00048C105.544 9.00048 104.833 9.71048 104.833 10.5711C104.833 11.4317 105.544 12.1417 106.406 12.1417Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105.156 14.5729V26.062L107.677 26.0836V14.5729H105.156Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2419 12.1417C67.1253 12.1417 67.8364 11.4532 67.8364 10.5711C67.8364 9.71049 67.1253 9.00049 66.2419 9.00049C65.38 9.00049 64.6689 9.71049 64.6689 10.5711C64.6689 11.4317 65.38 12.1417 66.2419 12.1417Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9922 14.5729V26.0621L67.5132 26.0836V14.5729H64.9922Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9105 17.6925C61.9105 12.3997 58.4199 9.30151 53.7227 9.30151H47V26.0834H53.6796C58.3553 26.0834 61.9105 22.9852 61.9105 17.6925ZM53.7011 23.7813H49.6503V11.5821H53.7227C56.9978 11.5821 59.2387 13.6906 59.2387 17.6925C59.2387 21.6943 56.9547 23.7813 53.7011 23.7813Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7518 16.1862V14.5725H82.122V26.6426C82.122 29.9344 79.8811 31.9999 76.4551 31.9999C73.0291 31.9999 71.1761 30.2787 70.7236 27.7829L73.2446 27.6968C73.4601 29.0308 74.7098 29.8699 76.3905 29.8699C78.3081 29.8699 79.601 28.8156 79.601 26.8147V24.7062C78.9761 25.6098 77.6617 26.2983 75.938 26.2983C72.7275 26.2983 70.4004 24.0177 70.4004 20.3386C70.4004 16.6595 72.749 14.3789 75.9595 14.3789C77.7479 14.3789 79.1269 15.1319 79.7518 16.1862ZM72.9645 20.3386C72.9645 22.7914 74.4081 24.1468 76.3474 24.1468C78.2435 24.1468 79.601 22.9204 79.601 20.6398V20.0374C79.601 17.7568 78.222 16.5304 76.3474 16.5304C74.4081 16.5519 72.9645 17.8859 72.9645 20.3386Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9694 12.1417C87.8528 12.1417 88.5639 11.4532 88.5639 10.5711C88.5639 9.71049 87.8528 9.00049 86.9694 9.00049C86.1075 9.00049 85.3965 9.71049 85.3965 10.5711C85.3965 11.4317 86.1075 12.1417 86.9694 12.1417Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7197 14.5729V26.0621L88.2407 26.0836V14.5729H85.7197Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6621 11.6469V16.3373H101.169V18.6824H94.6621V26.0621H91.9902V9.28027H102.548V11.6469H94.6621Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 37.0456,
    y1: 26.5358,
    x2: 20.7813,
    y2: 34.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 38.7131,
    y1: 29.7595,
    x2: 22.5024,
    y2: 38.1648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 5.01991,
    y1: 34.2323,
    x2: 9.43206,
    y2: 13.0249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1.89405,
    y1: 33.6017,
    x2: 6.25778,
    y2: 12.6266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 35.3812,
    y1: 23.3201,
    x2: 19.1019,
    y2: 31.7623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 8.19858,
    y1: 34.884,
    x2: 12.6254,
    y2: 13.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 33.2952,
    y1: 19.2973,
    x2: 17.0137,
    y2: 27.7374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 12.5218,
    y1: 35.7714,
    x2: 16.9486,
    y2: 14.4894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 17.3441,
    y1: 36.7616,
    x2: 21.771,
    y2: 15.4817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 11.6124,
    y1: 5.68221,
    x2: 30.2467,
    y2: 11.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 12.8415,
    y1: 1.80408,
    x2: 31.4758,
    y2: 7.70254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 10.3751,
    y1: 9.59597,
    x2: 29.0094,
    y2: 15.4944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 8.9931,
    y1: 13.9646,
    x2: 27.6253,
    y2: 19.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 7.5283,
    y1: 18.5903,
    x2: 26.1605,
    y2: 24.4909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 31.0034,
    y1: 14.8817,
    x2: 14.724,
    y2: 23.3218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.8a8645e1.svg";
export { ForwardRef as ReactComponent };